// Log de atividade do usuário (GPS Drive Backend) — aba LOGS em Editar
// Usuário. logActivity é chamado a partir de commands.service.ts (bloquear/
// desbloquear veículo), geofences.service.ts (criar/editar/excluir
// geocerca) e dos dois clientes HTTP (lib/api/client.ts e
// lib/api/gpsdrive-client.ts, para qualquer chamada mutante que falhar) —
// sempre best-effort (fire-and-forget, nunca lança) porque uma falha aqui
// nunca pode quebrar a ação real do usuário. getUserActivityLog é usado
// pela leitura administrativa (Editar Usuário → LOGS).
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export type ActivityLogType =
  | "LOGIN"
  | "ERROR"
  | "VEHICLE_BLOCK"
  | "VEHICLE_UNBLOCK"
  | "VEHICLE_COMMAND"
  | "GEOFENCE_CREATED"
  | "GEOFENCE_UPDATED"
  | "GEOFENCE_DELETED"
  // "Apagar histórico" (pedido 2026-09-08) — gravado pelo próprio GPS
  // Drive Backend (módulo history-deletions), nunca pelo frontend via
  // logActivity — por isso fica fora de LogActivityInput abaixo.
  | "HISTORY_DELETED"
  | "HISTORY_RESTORED"
  // Sintéticos — só aparecem na leitura (ver activity-log.service.ts no
  // backend), nunca enviados pelo POST.
  | "PUSH_SUBSCRIBED"
  | "NOTIFICATION_RECEIVED";

export interface LogActivityInput {
  type: Exclude<
    ActivityLogType,
    "PUSH_SUBSCRIBED" | "NOTIFICATION_RECEIVED" | "HISTORY_DELETED" | "HISTORY_RESTORED"
  >;
  message: string;
  metadata?: Record<string, unknown>;
  success?: boolean;
}

export interface ActivityLogEntry {
  id: string;
  type: ActivityLogType;
  message: string;
  metadata: Record<string, unknown> | null;
  success: boolean;
  createdAt: string;
}

export interface ActivityLogFilters {
  type?: ActivityLogType;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export interface ActivityLogPage {
  items: ActivityLogEntry[];
  total: number;
}

// Fire-and-forget de propósito — nenhum caller deve esperar isto nem
// tratar erro (a própria função já engole qualquer falha).
export function logActivity(input: LogActivityInput): void {
  void gpsDrivePost("/api/v1/activity-logs", input).catch(() => {});
}

export const activityLogService = {
  logActivity,
  getUserActivityLog: (userId: string, filters: ActivityLogFilters = {}): Promise<ActivityLogPage> => {
    const params = new URLSearchParams();
    if (filters.type) params.set("type", filters.type);
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    params.set("limit", String(filters.limit ?? 50));
    params.set("offset", String(filters.offset ?? 0));
    return gpsDriveGet<ActivityLogPage>(`/api/v1/users/${userId}/activity-logs?${params.toString()}`);
  },
};
